import { ThemeColors, ThemeMode } from './colors'

const CLAIM_STATUS_FALLBACKS = {
  Concept: (colors: ThemeColors) => colors.brand.primary,
  'In behandeling': (colors: ThemeColors) => colors.status.warning.foreground,
  Afgehandeld: (colors: ThemeColors) => colors.status.success.foreground,
  'Gemeld bij adviseur': (colors: ThemeColors) => colors.text.brand
} as const

const isHexColor = (value: string) => /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value)

export const rgbaFromHex = (hex: string, alpha: number) => {
  const normalized =
    hex.length === 4
      ? `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`
      : hex

  const r = parseInt(normalized.slice(1, 3), 16)
  const g = parseInt(normalized.slice(3, 5), 16)
  const b = parseInt(normalized.slice(5, 7), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const resolveClaimStatusColor = (
  status: string,
  statusColor: string,
  colors: ThemeColors,
  themeMode: ThemeMode
) => {
  if (themeMode === 'light' && isHexColor(statusColor)) {
    return statusColor
  }

  return (
    (status in CLAIM_STATUS_FALLBACKS
      ? CLAIM_STATUS_FALLBACKS[status as keyof typeof CLAIM_STATUS_FALLBACKS](colors)
      : undefined) ?? colors.text.secondary
  )
}
